import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import useDecode from "hooks/useDecode";
import useGetAdministrationSheets from "services/recordSheets/useGetAdministrationSheets";
import EntornoLaboral from "../Comun/EntornoLaboral";
import LoaderMin from "components/blocks/Loader/LoaderMin";
import { SheetPage, SheetHero, SheetPill, SheetSection, SheetGrid, SheetField, SheetDiagnosisField, SheetTextField, formatText, formatDate, buildEntornoLaboralProps } from "../SheetLayout";

const ParteConfirmacion: React.FC = () => {
  const params = useParams<{ detailId: string; id: string }>();
  const parteId = params.detailId?.split("__")[1];
  const prestacionId = params.id.split("_")[1];
  const { dataAdministrationSheet: d, loadingAdministrationSheet, errorAdministrationSheet, getConfirmationPart } = useGetAdministrationSheets();
  const userId = useDecode("token")?.extension_id;

  useEffect(() => { getConfirmationPart(userId, prestacionId, parteId); }, []);

  if (loadingAdministrationSheet) return <section className="container"><LoaderMin /></section>;
  if (errorAdministrationSheet) return <section className="container"><p className="loader-text">Lo sentimos, se ha producido un error.</p></section>;
  if (!d) return <section className="container"><p className="loader-text">No hay datos para mostrar.</p></section>;

  return (
    <SheetPage>
      <SheetHero
        title="Parte de Confirmación"
        icon="check-circle"
        pills={<>
          {d.numeroParte && <SheetPill label="Nº Parte" value={formatText(d.numeroParte)} />}
          <SheetPill label="Fecha" value={formatDate(d.fechaParte)} icon="calendar" />
        </>}
      />

      <SheetSection title="Detalles" icon="file-text">
        <SheetGrid>
          <SheetField label="Fecha parte"                value={formatDate(d.fechaParte)} />
          <SheetField label="Número parte"               value={formatText(d.numeroParte)} />
          <SheetField label="Fecha revisión"             value={formatDate(d.fechaRevision)} />
          <SheetField label="Fecha pase control INSS"    value={formatDate(d.fechaPaseControlInss)} />
          <SheetField label="Estimación días"            value={formatText(d.estimacionDias)} />
          <SheetField label="Duración tratamiento"       value={formatText(d.duracionTratamiento)} />
          <SheetField label="Limitación funcional"       value={formatText(d.descripcionLimitacion)} />
          <SheetField label="Tipo de proceso"            value={formatText(d.tipoProcesoDescripcion)} />
          <SheetDiagnosisField label="Diagnóstico CIE9"  code={d.codigoDiagnosticoCIE9 || ""} desc={d.descripcionCIE9 || ""} wide />
          <SheetDiagnosisField label="Diagnóstico CIE10" code={d.codigoDiagnosticoCIE10 || ""} desc={d.diagnosticoCIE10Descripcion || ""} wide />
          <SheetField label="Nombre facultativo"         value={formatText(d.nombreFacultativo)} />
          <SheetField label="Número colegiado"           value={formatText(d.numeroFacultativo)} />
          <SheetField label="CIAS facultativo"           value={formatText(d.CIASFacultativo)} />
        </SheetGrid>
      </SheetSection>

      {d.entornoLaboral && <EntornoLaboral {...buildEntornoLaboralProps(d)} />}
    </SheetPage>
  );
};

export default ParteConfirmacion;
